<template>
  <BaseModal modal-content-class="first_daily">
    <div class="content">
      <h2>{{ $_translations.value.modal_bonus_phase_daily_title }}</h2>

      <p>{{ $_translations.value.modal_bonus_phase_daily_subtitle }}</p>

      <p>{{ $_translations.value.modal_bonus_phase_daily_reward_description }}</p>

      <RewardBoxItem
        :prize-value="prizeValue"
        :prize-type="prizeType"
      />

      <BaseButton
        :button-class="['fancy_btn', {close_modal: ignoreRedirection}]"
        @click:button="handleProceed"
      >
        {{ $_translations.value.modal_bonus_phase_daily_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import RewardBoxItem from '@/components/item/RewardBoxItem.vue';

const emits = defineEmits(['redirect:homePage']);

const props = defineProps({
  prizeValue: {
    type: Number,
    default: 0,
  },
  prizeType: {
    type: String,
    default: '',
  },
  ignoreRedirection: {
    type: Boolean,
    default: false,
  },
});

const handleProceed = () => {
  if (props.ignoreRedirection) { return; }

  emits('redirect:homePage');
};
</script>
